export const forbiddenWords = [
    'phone',
    'cell',
    'text me',
    'call me',
    'email',
    'gmail',
    'yahoo',
    'Aol',
    'icloud',
    'my number is',
    'reach me at',
    'contact me',
    'WhatsApp',
    'Telegram',
    'Signal',
    'iMessage',
    'FaceTime',
    'Instagram',
    'Facebook',
    'Face book',
    'venmo',
    'Cashapp',
    'zelle',
    'Paypal',
    'Pay pal',
    'Applepay',
    'Apple pay',
    'square',
    'direct deposit',
    'bank transfer',
    'wire transfer',
    'send you money',
    'cash',
    'in cash',
    'pay you directly',
    'pay outside',
    'outside the app',
    'off platform',
    'pay you offline',
    'Pay you in person',
    'Pay in person',
    'under the table',
    'skip the app',
    'no fees',
    'avoid fees',
    'send to you',
    'at gmail dot com',
    'dot com',
    'at yahoo dot com',
    'my email is',
    '@',
    '.com',
    '.net',
    '123-456-7890',
    '(123)',
    'five five five',
    'one two three',
    'let’s talk somewhere else',
    'connect offline',
    'other site',
    'i’ll send you my info',
    'you got IG?',
    'check your DMs',
    'follow me here',
    'Crashpad411',
    'Vrbo',
    'Airbnb',
    'Crashpads411',
    'Purecrashpads',
    'Pure crashpad',
    'Hotel Crash Pad Network',
    'Hotel Crashpad Network',
    'Purecrashpad',
]

export function checkPhoneNumberOrKeywords(inputMessage) {
    const phoneRegex = /\b(\d{3}-\d{3}-\d{4}|\d{10})\b/

    // Adjust forbidden words for flexible matching
    const adjustedForbiddenWords = forbiddenWords.map(word => {
        const escapedWord = word.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        return escapedWord.split('').join('\\s*')
    })

    const keywordRegex = new RegExp(`(${adjustedForbiddenWords.join('|')})`, 'i')

    const spelledOutNumbersRegex = /\b(?:zero|one|two|three|four|five|six|seven|eight|nine)(?:\s+(?:zero|one|two|three|four|five|six|seven|eight|nine)){2,}\b/i

    const normalizedMessage = inputMessage.replace(/\s+/g, ' ')

    const specialCharacterRegex = /[@.](com|net|gmail|yahoo|icloud|aol)/i
    return (
        phoneRegex.test(normalizedMessage) ||
        keywordRegex.test(normalizedMessage) ||
        spelledOutNumbersRegex.test(normalizedMessage) ||
        specialCharacterRegex.test(normalizedMessage)
    )
}
